import { CategoryTag } from "@/pages/delays/delays-manager/components/CategoryTag";
import { HeatReportDelay } from "@/pages/heat-report/models/HeatReportModels";
import { getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
	const columns: ColGroupDef[] = [
		{
			headerName: "Delays",
			children: [
				{
					field: "Start",
					headerName: "Start",
					flex: 1,
					minWidth: 55,
					valueGetter: (params: any) => {
						if (params.data.Start) {
							return moment((params.data as HeatReportDelay).Start).format(
								"HH:mm:ss",
							);
						}
					},
				},
				{
					field: "End",
					headerName: "End",
					flex: 1,
					minWidth: 76,
					valueGetter: (params: any) => {
						if (params.data.End) {
							return moment((params.data as HeatReportDelay).End).format(
								"HH:mm:ss",
							);
						}
					},
				},
				{
					field: "Duration",
					headerName: "Duration",
					flex: 1,
					minWidth: 64,
					valueFormatter: (params) => {
						if (params.value) {
							const duration = moment.duration(params.value, "seconds");
							const minutes = Math.floor(duration.asMinutes());
							const seconds = duration.seconds();
							return `${minutes}m ${seconds}s`;
						}
						return "";
					},
				},
				{
					field: "DelayCategory",
					headerName: "Category",
					valueGetter: (params) => {
						const delayCategoryName = params.data?.DelayCategoryName;
						const delayCategoryColor = params.data?.DelayCategoryColor;
						return { name: delayCategoryName, color: delayCategoryColor };
					},
					cellRenderer: CategoryTag,
					minWidth: 180,
					maxWidth: 200,
					editable: false,
					cellStyle: { justifyContent: "flex-start" },
					flex: 1,
				},
				{
					field: "DelayCodeName",
					headerName: "Code",
					valueGetter: (params) =>
						params.data?.DelayCodeName || "No Classified",
					minWidth: 130,
					editable: false,
					flex: 1,
					cellStyle: { justifyContent: "center" },
				},
				{
					field: "Comments",
					headerName: "Comments",
					minWidth: 117,
					flex: 3,
				},
			],
		},
	];

	const defaultColDef: ColDef = {
		filter: false,
		floatingFilter: false,
		sortable: false,
		wrapText: true,
		autoHeight: true,
		wrapHeaderText: true,
		resizable: false,
		editable: false,
		suppressHeaderMenuButton: true,
	};

	return { columns, defaultColDef };
};
